<script>
import Layout from '@layouts/primary'
import { vehicleMethods } from '@state/helpers'
import ListLoading from '@components/loading'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'VehicleReports',
    meta: [{ name: 'description', content: 'VehicleReports' }],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      search: '',
      loadingData: true,
      headers: [
        { text: 'Truck Registration', value: 'numberPlate' },
        { text: 'Kilometers Performed', value: 'kms' },
        { text: 'Litres Used', value: 'litresUsed' },
        { text: 'KM per Litre', value: 'kmPerLitre' },
        { text: 'Date', value: 'date' },
        // { text: 'Actions', value: 'name', sortable: false },
      ],
      vehicles: [],
      petrolData: [],
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          // name: {
          //   required: () => 'Name can not be empty',
          //   max: 'The name field may not be greater than 10 characters',
          //   // custom messages
          // },
          select: {
            required: 'Select field is required',
          },
        },
      },
      addRunSheet: false,
    }
  },
  async mounted() {
    this.$validator.localize('en', this.dictionary);
    let moment = require('moment');
    await this.getVehicles().then(response => {
      // console.log('response', response)
      // let obj = response;
      let obj = this.$store.state.vehicles.objects;
      // console.log(obj)
      for (let v in obj) {

        // Compare fuels
        let fuelObjs = obj[v].vehicle_trip_info;
        let petrolData = [];

        for(let fuel in fuelObjs){
          // Next Item to compare data
          let nextIndex = parseInt(fuel);
          nextIndex += 1;

          let kmPerformed = '';
          let vehicleConsumption = {
            kms: '',
            litresUsed: '',
            kmPerLitre: '',
            numberPlate: '',
            date: ''
          };

          // Only calculate if there is a next value
          if(fuelObjs[fuel].mileage && (fuelObjs[nextIndex] && fuelObjs[nextIndex] !== undefined)){
            kmPerformed = fuelObjs[nextIndex].mileage - fuelObjs[fuel].mileage;

            // Add to Obj only vehicle data
            if(fuelObjs[nextIndex].litres !== null && kmPerformed !== null){

              vehicleConsumption.litresUsed = fuelObjs[nextIndex].litres;
              vehicleConsumption.kms = kmPerformed;
              vehicleConsumption.kmPerLitre = (kmPerformed / fuelObjs[nextIndex].litres).toFixed(2);
              vehicleConsumption.numberPlate = fuelObjs[fuel].number_plate;

              let day = moment.unix(fuelObjs[fuel].created_at / 1000);
              vehicleConsumption.date = day.format('DD/MM/YYYY');

              petrolData.push(vehicleConsumption);
              this.petrolData.push(vehicleConsumption);
            }
          }
        }
        this.petrolData = petrolData;
        // console.log('petrol', petrolData)
      }

      this.loadingData=false
      // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })
  },
  methods: {
    ...vehicleMethods,
    submit() {

    },
    clear() {
      this.$validator.reset()
      this.addRunSheet = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Vehicle Reports
        </h2>
        <ListLoading :display="loadingData" />
      </div>

      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="headers"
        :items="petrolData"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.numberPlate }}
          </td>
          <td
            class="text-xs-left"
          >
            {{ props.item.litresUsed }}
          </td>
          <td
            class="text-xs-left"
          >
            {{ props.item.kms }}
          </td>

          <td
            class="text-xs-left"
          >
            {{ props.item.kmPerLitre }}
          </td>

          <td
            class="text-xs-left"
          >
            {{ props.item.date }}
          </td>

        </template>
      </VDataTable>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .routeHeader {
    display: inline-block;
  }

  .addButton {
    display: inline-block;
    float: right;
  }
</style>
